import React, { useState, useRef, useEffect } from 'react'
import DataTable from '../../../Components/DataTable/DataTable';
import { Button, Modal, FormGroup, Form, Label, Input, ModalBody } from 'reactstrap';
import "../../pages.css"
import Header from '../../../Layout/User/Header';
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { enGB } from "date-fns/locale";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { format } from "date-fns";

import RegularModal from '../../../Components/Modals/RegularReservationModal';
import EditModal from '../../../Components/Modals/EditReservationModal';
import EmailReportModal from '../../../Components/Modals/EmailReportModal';
import withAuth from "../../../Components/CheckSessionStorage/sessionUtils";
import apiRequest from '../../../api';

const Home = () => {
  const selectedLanguageRef = useRef(localStorage.getItem('Language'));
  const columns_en = [{ title: 'Name', key: "name" }, { title: 'Seating Arrangement', key: "seats" }, { title: "Time slot", key: "startDate" }];
  const columns_rs = [{ title: 'Ime', key: "name" }, { title: 'Postavka', key: "seats" }, { title: "Vreme", key: "startDate" }];

  const [columns, setColumns] = useState(() => {
    return (selectedLanguageRef.current === "EN" ? columns_en : columns_rs);
  });

  useEffect(() => {
    // Handle changes from other tabs/windows and local changes
    const handleLanguageChange = (event) => {
      selectedLanguageRef.current = event.detail['selectedLanguage'];
      setColumns(selectedLanguageRef.current === "EN" ? columns_en : columns_rs)
      const translationMap = {
            "Manager (max 44)": "Manager (max 44)",
            "Theater (max 56)": "Theater (max 56)",
            "Menadžerska (max 44)": "Manager (max 44)",
            "Bioskopska (max 56)": "Theater (max 56)",
            "Training": "Trening",
            "Trening": "Training",
            "Custom": "Prilagođeno",
            "Prilagođeno": "Custom",
      };
      setData(prevData =>
        prevData.map(item => ({
          ...item,
          seats: translationMap[item.seats]
        })));
      setFilteredData(prevData =>
        prevData.map(item => ({
          ...item,
          seats: translationMap[item.seats]
        })));
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // To manage loading state
  const [error, setError] = useState(null); // To manage error state

  const [modalOpen, setModalOpen] = useState(false);
  const [visibleRows, setVisibleRows] = useState(1);
  const [editModal, setEditModal] = useState(false)

  const [filteredData, setFilteredData] = useState([]); // To manage the data displayed in the table

  useEffect(() => {
    if (data.length > 0) {
      const now = new Date();
      const sortedData = [...data].sort((a, b) => a.startDate - b.startDate);

      if (visibleRows === 1 && data.length != 1) {
        // Find the nearest future reservation
        const futureReservations = data.filter((reservation) => reservation.endDate > now);

        setFilteredData(futureReservations.length > 0 ? [[...futureReservations].sort((a, b) => a.startDate - b.startDate)[0]] : []);
      } else {
        // Show all reservations
        setFilteredData(sortedData);
      }
    }
    else{
      setFilteredData([]);
    }
  }, [data, visibleRows]);

  const handleShowMore = () => {
    // Toggle between showing all reservations and only the nearest future reservation
    setVisibleRows((prev) => (prev === 1 ? data.length : 1));
  };
  const [selectedRow, setSelectedRow] = useState({
    start_time: new Date(),
    end_time: new Date(),
    name: "",
    seats: "",
    id: "",
    notes: "",
  });
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const toggleEditModal = (row) => {
    if (editModal === true) {
      // Close modal, no need for additional action when closing
      setEditModal(false);
    } else {
      setSelectedRow({
        start_time: row.startDate,
        end_time: row.endDate,
        name: row.name,
        id: row.id,
        seats: row.seats,
        notes: row.notes,
      });
      setEditModal(true);
    }
  };
  const fetchReservations = async () => {
    try {
      // Retrieve JWT from localStorage
      const token = sessionStorage.getItem("jwt");

      const reservations = await apiRequest('/api/reservations/get_my_reservations', 'GET', null, token);
      const translationMap = {
            "Manager (max 44)": "Manager (max 44)",
            "Theater (max 56)": "Theater (max 56)",
            "Menadžerska (max 44)": "Manager (max 44)",
            "Bioskopska (max 56)": "Theater (max 56)",
            "Training": "Trening",
            "Trening": "Training",
            "Custom": "Prilagođeno",
            "Prilagođeno": "Custom",
      };
      const formattedData = reservations.map((reservation) => {
        const startDate = new Date(reservation.startTime);
        const endDate = new Date(reservation.endTime);

        return {
          name: reservation.name,
          startDate: startDate,
          endDate: endDate,
          id: reservation.reservationCode,
          notes: reservation.notes,
          seats: selectedLanguageRef.current === 'RS' ? translationMap[reservation.seats] : reservation.seats,
        };
      });

      setData(formattedData);
      if(visibleRows != 1){
        setVisibleRows(formattedData.length);
      }
      console.log("Data:", formattedData);
    } catch (err) {
      setError(err.message);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loading
      await fetchReservations(); // Fetch data
      setLoading(false); // Stop loading
    };

    fetchData();
  }, []); // Runs only once when the component is mounted



  if (loading) {
    return <Header />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }


  return (
    <React.Fragment>
      <Header />
      <div className='container  ' >
        <div className='table-container-1 ' >
          <div className='row  my-3 ' >
            <div className='col-12 text-end ' >

              <Button onClick={toggleModal} className='add-btn float-end me-0'  >+</Button>
            </div>
          </div>

          <div className='row' style={{ position: "relative" }} >
            <div className='col-12 text-end ' >
              <DataTable onEdit={(row) => toggleEditModal(row)} data={filteredData} fetchReservations={() => fetchReservations()} columns={columns} visibleRows={visibleRows} />
            </div>
          </div>

          <div className='row justify-content-end align-items-center my-3'>
            <div className='col-6 text-end'>
              {data.length > 1 && (
                <Button className='show-btn' onClick={handleShowMore}>
                  {visibleRows === 1 ?
                    `${selectedLanguageRef.current === "EN" ? "Show more" : "Više"}` :
                    `${selectedLanguageRef.current === "EN" ? "Show less" : "Manje"}`
                  }
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
      <RegularModal
        isOpen={modalOpen}
        toggle={toggleModal}
        fetchReservations={fetchReservations}
        selectedDate={new Date()}
      />
      <EditModal
        isOpen={editModal}
        toggle={toggleEditModal}
        selectedRow={selectedRow}
        fetchReservations={fetchReservations}
      />
    </React.Fragment>
  )
}

export default withAuth(Home)